module.exports = __webpack_public_path__ + "img/img3.b36c64ba.jpg";